import { useState, useEffect, useCallback } from 'react';

interface NavItem {
  label: string;
  anchor: string;
}

const navItems: NavItem[] = [
  { label: '首页', anchor: '#hero' },
  { label: '最新动态', anchor: '#updates' },
  { label: 'APP下载', anchor: '#app' },
  { label: '热门吃瓜', anchor: '#cards' },
  { label: '视频专区', anchor: '#media' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const handleNavClick = (anchor: string) => {
    setMobileOpen(false);
    const el = document.querySelector(anchor);
    if (el) {
      const headerH = 64;
      const top = el.getBoundingClientRect().top + window.scrollY - headerH;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-surface-950/95 backdrop-blur-md border-b border-surface-800'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-2 group cursor-pointer"
        >
          <span className="w-8 h-8 flex items-center justify-center bg-brand-500 rounded-lg">
            <i className="ri-fire-line text-white text-lg"></i>
          </span>
          <span className="text-white font-display text-xl tracking-wide">每日大赛</span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.anchor}
              href={item.anchor}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.anchor); }}
              className="px-4 py-2 text-surface-300 hover:text-white text-sm font-medium rounded-lg hover:bg-surface-800/60 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#app"
            onClick={(e) => { e.preventDefault(); handleNavClick('#app'); }}
            className="ml-2 px-5 py-2 bg-brand-500 hover:bg-brand-600 text-white text-sm font-semibold rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            立即下载
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-surface-950/98 backdrop-blur-md border-t border-surface-800 animate-fade-in">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.anchor}
                href={item.anchor}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.anchor); }}
                className="px-4 py-3 text-surface-300 hover:text-white text-sm font-medium rounded-lg hover:bg-surface-800/60 transition-all duration-200 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#app"
              onClick={(e) => { e.preventDefault(); handleNavClick('#app'); }}
              className="mt-2 px-4 py-3 bg-brand-500 hover:bg-brand-600 text-white text-sm font-semibold rounded-lg text-center transition-all duration-200 cursor-pointer"
            >
              立即下载APP
            </a>
          </div>
        </div>
      )}
    </header>
  );
}